import { PANEL_CONTEST, PANEL_ERROR, PANEL_MAIN, PANEL_SALON_ITEM, PANEL_TUNING } from '../router';

export const forbidTabbar = [PANEL_MAIN, PANEL_SALON_ITEM, PANEL_TUNING, PANEL_CONTEST, PANEL_ERROR];
